<section class="h-full flex flex-col">
  <app-modal-header title="Get in touch" (onClose)="dialogRef.close()" [send]="!error && !success" (onSend)="send()"
                    [processing]="submitting"></app-modal-header>

  <mat-dialog-content>
    <form [formGroup]="form">

      <div class="dm-input">
        <label for="">How can we help you?</label>
        <textarea type="text" formControlName="message" rows="5" [autofocus]="true"></textarea>
        <small class="red" *ngIf="message.touched && message.invalid">Required</small>
      </div>

<!--          Report a bug-->
<!--          Request a feature-->
<!--          Request integration-->
    </form>

    <p class="p-6 bg-red-50 rounded-control text-gray-800" *ngIf="error">
      <i class="fas fa-exclamation-triangle mr-1 text-red-600"></i>
      So ironic... The "report an error" function is currently unavailable. We
      apologize for the inconvenience and promise to get it back up and running ASAP.
      <br>
      Meanwhile you can contact us at <button class="btn btn-sm btn-flat" (click)="helperSvc.copyText('info@datamorf.io')">info&#64;datamorf.io</button>
    </p>
    <p class="p-6 bg-green-50 rounded-control text-gray-800" *ngIf="success">
      <i class="fas fa-check-circle mr-1 text-green-600"></i>
      Message sent! We will action it ASAP. Thank you!
    </p>

  </mat-dialog-content>
</section>
